import {NSFunctions} from './utils/functions'
import {xCore} from './core';
import { URN as NSURN } from './utils/urn';
import { NSTables } from './utils/tables';
import { NSDataModelInfo } from './data_model_info';
import { NSDataTypes } from './utils/data_types';
import { NSPageBottompanel} from './page_bottompanel';
import { NSGeoJson } from './utils/geojson';
import { NSPageLabels } from './page_labels';
import { NSCombos } from './utils/combos';
import { NSServerCalls } from './utils/servercalls';
import { NSObjDetails } from './obj_details';
import { NSDateDatetime } from './utils/date_datetime';
import { NSFeaturesSelect } from './map_features_select';
import { NSObjDetailsCloneData } from './obj_details_clone_data';
import { NSMessages } from './utils/messages'
import { NSMapInterface } from './map_interface'

import EyeSlashIcon from 'bootstrap-icons/icons/eye-slash.svg?raw';
import ChevronLeftIcon from 'bootstrap-icons/icons/chevron-left.svg?raw';
import ChevronRightIcon from 'bootstrap-icons/icons/chevron-right.svg?raw';
import CloudDownloadIcon from 'bootstrap-icons/icons/cloud-download.svg?raw';
import ClipboardFillIcon from 'bootstrap-icons/icons/clipboard-fill.svg?raw';
import CheckIcon from 'bootstrap-icons/icons/check.svg?raw';
import CloseIcon from 'bootstrap-icons/icons/x.svg?raw';

export let NSResultsInterface = {};

NSResultsInterface.init = function()
{
    NSResultsInterfacePrivate.init();
	
	//this.init = 	function () { return NSResultsInterfacePrivate.init.apply( NSResultsInterfacePrivate, arguments ); };
	this.f_reset_results_interface =		function () { return NSResultsInterfacePrivate.f_reset_results_interface.apply( NSResultsInterfacePrivate, arguments ); };
	this.f_clean_results_interface =		function () { return NSResultsInterfacePrivate.f_clean_results_interface.apply( NSResultsInterfacePrivate, arguments ); };

    
	//window.NSResultsInterface_ = NSResultsInterface;
	window.NSResultsInterfacePrivate_ = NSResultsInterfacePrivate;
	
}

let NSResultsInterfacePrivate = 
{
    private_objs:
	{
		s_e_holder_id: "resultspage",
		e_holder: null,
		


		e_div_table_results_interface_holder: null,
		
		e_div_res_interface_title: null,
		e_div_res_interface_tables_holder: null,

		e_div_results_interface_pagination_buttons: null,
		e_button_results_interface_previous_page: null,
		e_button_results_interface_next_page: null,
		e_pagination_counter: null,
		
		e_button_results_interface_clean_results: null,
		e_div_results_interface_export: null,
		e_select_results_interface_export_format: null,
		e_button_results_interface_export_execute: null,

		
		o_input_data: null,
		
		o_tables: {
			a_o_collection: null,	//[NSResultsInterfacePrivate.objs.Collection];
			
		}
		
		

	},

    init: function()
    {
        let private_objs = this.private_objs;
		this.private_objs.e_holder = document.getElementById(private_objs.s_e_holder_id);
		
		this.objs.init_();

    },

    f_run_init_interface: function()
	{
		let private_objs = this.private_objs;
		
		
		if(!private_objs.o_input_data.b_get_more_results_response)
		{
			this.f_init_tab_content();
		}
		
		
	},
	
	f_init_tab_content: function()
	{
		let this_ = this;
		let private_objs = this.private_objs;
		
		let e_holder = document.getElementById(private_objs.s_e_holder_id);
		private_objs.e_holder = e_holder;

		let s_label_results_interface_button_clean_tool_tip = NSPageLabels.f_get_label_text_by_internal_name("results_interface_button_clean_tool_tip");
		let s_results_interface_excute_tooltip = NSPageLabels.f_get_label_text_by_internal_name("results_interface_excute_tooltip");
		
		let s_html = `
			<div id="div_results_interface_holder" class="page-content">
				<div id="div_results_interface_header">
					<div id="div_results_interface_pagination_buttons" class="btn-group">
						<button id="button_results_interface_clean_results" type="button" class="btn btn-sm btn-outline-secondary" title="${s_label_results_interface_button_clean_tool_tip}" aria-hidden="true">${EyeSlashIcon}</button>
						<button id="button_results_interface_previous_page" type="button" class="btn btn-sm btn-outline-secondary" title="Página Anterior">${ChevronLeftIcon}</button>
						<button id="button_results_interface_next_page" type="button" class="btn btn-sm btn-outline-secondary" title="Página Seguinte">${ChevronRightIcon}</button>
					</div>
					${
						!private_objs.o_input_data.b_enable_paste 
						? '' 
						: `<button id="button_results_interface_paste" type="button" class="btn btn-sm btn-outline-secondary" title="Colar" aria-hidden="true">${ClipboardFillIcon}</button>`
					}
					<span id="pagination_counter"></span>
					<div id="div_results_interface_export" class="input-group input-group-sm">
						<button id="button_results_interface_export_execute" type="button" class="btn btn-sm btn-outline-secondary" title="${s_results_interface_excute_tooltip}">${CloudDownloadIcon}</button>
						<select id="select_results_interface_export_format" class="form-select form-select-sm"></select>
					</div>
				</div>
				<div id="div_res_interface_tables_holder"></div>
				<div id="div_res_interface_noresults">Sem Resultados</div>
			</div>
		`;

		e_holder.innerHTML = s_html;
		
		let e_div_results_interface_holder = document.getElementById("div_results_interface_holder");
		private_objs.e_div_results_interface_holder = e_div_results_interface_holder;
		
		let e_div_res_interface_title = document.getElementById("div_res_interface_title");
		private_objs.e_div_res_interface_title = e_div_res_interface_title;
		
		let e_div_res_interface_tables_holder = document.getElementById("div_res_interface_tables_holder");
		private_objs.e_div_res_interface_tables_holder = e_div_res_interface_tables_holder;
		
		let e_div_res_interface_noresults = document.getElementById("div_res_interface_noresults");
		private_objs.e_div_res_interface_noresults = e_div_res_interface_noresults;
		
		let e_div_results_interface_pagination_buttons = document.getElementById("div_results_interface_pagination_buttons");
		private_objs.e_div_results_interface_pagination_buttons = e_div_results_interface_pagination_buttons;

		let e_button_results_interface_previous_page = document.getElementById("button_results_interface_previous_page");
		private_objs.e_button_results_interface_previous_page = e_button_results_interface_previous_page;
		e_button_results_interface_previous_page.onclick = function(){this_.o_pagination_struct.f_onclick_button_previous();};

		let e_button_results_interface_next_page = document.getElementById("button_results_interface_next_page");
		private_objs.e_button_results_interface_next_page = e_button_results_interface_next_page;
		e_button_results_interface_next_page.onclick = function(){this_.o_pagination_struct.f_onclick_button_next();};

		let e_pagination_counter = document.getElementById("pagination_counter");
		private_objs.e_pagination_counter = e_pagination_counter;		

		let e_button_results_interface_clean_results = document.getElementById("button_results_interface_clean_results");
		private_objs.e_button_results_interface_clean_results = e_button_results_interface_clean_results;
		e_button_results_interface_clean_results.onclick = function(){this_.f_onclick_clean_results();};
		
		let e_div_results_interface_export = document.getElementById("div_results_interface_export");
		private_objs.e_div_results_interface_export = e_div_results_interface_export;

		let e_select_results_interface_export_format = document.getElementById("select_results_interface_export_format");
		private_objs.e_select_results_interface_export_format = e_select_results_interface_export_format;

		let e_button_results_interface_export_execute = document.getElementById("button_results_interface_export_execute");
		private_objs.e_button_results_interface_export_execute = e_button_results_interface_export_execute;
		e_button_results_interface_export_execute.onclick = function(){this_.o_export_struct.f_onclick_button_execute();};

		if (private_objs.o_input_data.b_enable_paste) {
			let e_button_results_interface_paste = document.getElementById("button_results_interface_paste");
			e_button_results_interface_paste.onclick = function(){this_.f_onclick_paste_clipboard(private_objs.o_input_data.a_table);};
		}
		
		let b_show_table = false;
		this.f_show_hide_table(b_show_table);
	},
	
	f_onclick_paste_clipboard : function(data) {
		var config = NSObjDetailsCloneData.f_get_store_data_config();
		var dataset = config["dataset"];
		var collection = config["collection"];
		var parent_collection = config["parentCollection"];
		
		var collection_info = NSDataModelInfo.f_get_table_info(dataset, collection);
		var parent_collection_info = NSDataModelInfo.f_get_table_info(dataset, parent_collection);

		var clipboard_data = NSObjDetailsCloneData.f_get_store_data();
		
		var get_inputs_text = function() {
			var text = [];

			for (const input of clipboard_data.input_params) {
				if (input.name === 'id') continue;

				var name = collection_info.extra.a_column_info_ref_by_internal_name[input.name].external_name;
				var value = input.value;

				text.push(`<b>${name} = ${value}</b>`);
			}

			return text.join('<br>');
		}

		var s_msg = 
		`<div>
			Vai ser adicionado um novo objecto do tipo <b>${collection_info.external_name}</b> a todos os objectos seleccionados do tipo <b>${parent_collection_info.external_name}</b>
			<br>
			com os seguintes detalhes : 
		</div>
		<div>
			${get_inputs_text()}
		</div>
		<div class="btn-group">
			<button id="button_execute_paste" type="button" class="btn btn-sm btn-outline-secondary">${CheckIcon}</button>
			<button id="button_cancel_paste" type="button" class="btn btn-sm btn-outline-secondary">${CloseIcon}</button>
		</div>`;

		NSMessages.f_show_information(s_msg, 10000)					
		
		$("#button_execute_paste").on('click', function(){
			const features = data.filter(el => el.s_table_urn === NSURN.f_create_table_urn(dataset, parent_collection))[0].a_geojson_feature.map(el => ({id: NSURN.f_get_urn_record_id(el.urn), bbox: el.bbox}));
			NSObjDetailsCloneData.f_execute_paste(features);
			NSMessages.f_hide_information();
		})
		
		$("#button_cancel_paste").on('click', function(){
			NSMessages.f_hide_information();
		})
	},

	f_onclick_clean_results : function(){

		let  private_objs = this.private_objs;
		// id==resultspage
        private_objs.e_holder.innerHTML = '';
        
		NSResultsInterfacePrivate.private_objs.o_input_data = {};
		
		NSFeaturesSelect.f_clear_highlight();
		
        /* AQUIIIIIIIIIIIIIIIIIIII TO DO TODO
        xCore.state.selected_objects = [];
        */
	},
	
	f_show_hide_table: function(b_show_table)
	{
		let private_objs = this.private_objs;
		
		let e_div_res_interface_tables_holder = private_objs.e_div_res_interface_tables_holder;
		let e_div_res_interface_noresults = private_objs.e_div_res_interface_noresults;
		e_div_res_interface_tables_holder.style.display = (b_show_table)? '': 'none';
		e_div_res_interface_noresults.style.display = (!b_show_table)? '': 'none';
	},

	f_refresh_pagination_buttons_display: function()
	{
		let private_objs = NSResultsInterfacePrivate.private_objs;
		let o_input_data = private_objs.o_input_data;
		if(o_input_data.b_use_pagination)
		{
			delete private_objs.e_button_results_interface_clean_results.style['border-top-right-radius'];
			delete private_objs.e_button_results_interface_clean_results.style['border-bottom-right-radius'];
			private_objs.e_button_results_interface_previous_page.classList.remove('d-none');
			private_objs.e_button_results_interface_next_page.classList.remove('d-none');
			private_objs.e_pagination_counter.classList.remove('d-none');
		}
		else
		{
			private_objs.e_button_results_interface_clean_results.style['border-top-right-radius'] = '0.25rem';
			private_objs.e_button_results_interface_clean_results.style['border-bottom-right-radius'] = '0.25rem';
			private_objs.e_button_results_interface_previous_page.classList.add('d-none');
			private_objs.e_button_results_interface_next_page.classList.add('d-none');
			private_objs.e_pagination_counter.classList.add('d-none');
		}
	},
	
	f_refresh_export_div_display: function()
	{
		let private_objs = NSResultsInterfacePrivate.private_objs;
		let o_input_data = private_objs.o_input_data;
		let e_div_results_interface_export = private_objs.e_div_results_interface_export;
		if(o_input_data.b_enable_export)
		{
			e_div_results_interface_export.style.display = null;
		}
		else
		{
			e_div_results_interface_export.style.display = 'none';	
		}
	},

    /*
        o_in:
        {
            a_table, -> [{ s_table_urn, a_geojson_feature }]  

			b_join_list_call
			b_text_search_list_call
			b_enable_export
			b_use_pagination
			b_get_more_results_response		-> this call is the f_get_more_results response
			i_feature_limit					-> total results in db (not necessarily the returned count)
			i_feature_total_count			-> total results in db (not necessarily the returned count)
			i_feature_offset				-> offset of first feature in result (start) -> value is 0 based
			f_get_more_results				-> function to call to get more results (pagination)
											->	f_get_more_results(o_get_more_results_in)
											-> 		o_get_more_results_in = {
														i_feature_offset,
														i_feature_limit
													}

			
        }

        ex: 
        {
            a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
        }
    */
    f_reset_results_interface: function (o_in)
	{
		if(o_in.b_use_pagination && o_in.b_get_more_results_response)
		{
			this.private_objs.o_input_data.b_use_pagination = true;
			this.private_objs.o_input_data.b_get_more_results_response = true;
			this.private_objs.o_input_data.i_feature_offset = this.private_objs.o_input_data.i_feature_offset;;

			o_in.b_join_list_call = 			this.private_objs.o_input_data.b_join_list_call;
			o_in.b_text_search_list_call = 		this.private_objs.o_input_data.b_text_search_list_call;
			o_in.b_enable_export = 				this.private_objs.o_input_data.b_enable_export;
			//o_in.b_use_pagination = 			this.private_objs.o_input_data.b_use_pagination;
			o_in.b_enable_paste = 				this.private_objs.o_input_data.b_enable_paste;
			o_in.b_get_more_results_response = 	this.private_objs.o_input_data.b_get_more_results_response;
			o_in.i_feature_limit = 				this.private_objs.o_input_data.i_feature_limit;
			o_in.i_feature_total_count = 		this.private_objs.o_input_data.i_feature_total_count;
			//o_in.i_feature_offset = 			this.private_objs.o_input_data.i_feature_offset;
			o_in.f_get_more_results = 			this.private_objs.o_input_data.f_get_more_results;

			this.private_objs.o_input_data = o_in;
		}
		else
		{
			o_in.b_join_list_call = 			(o_in.b_join_list_call == true)? true : false;
			o_in.b_text_search_list_call = 		(o_in.b_text_search_list_call == true)? true : false;
			o_in.b_enable_export = 				(o_in.b_enable_export == true)? true : false;
			o_in.b_use_pagination = 			(o_in.b_use_pagination == true)? true : false;
			o_in.b_enable_paste = 				(o_in.b_enable_paste == true)? true : false;
			o_in.b_get_more_results_response = 	(o_in.b_get_more_results_response == true)? true : false;
			o_in.i_feature_limit = 				(o_in.i_feature_limit != null)? o_in.i_feature_limit : null;
			o_in.i_feature_total_count = 		(o_in.i_feature_total_count != null)? o_in.i_feature_total_count : null;
			o_in.i_feature_offset = 			(o_in.i_feature_offset != null)? o_in.i_feature_offset : null;
			o_in.f_get_more_results = 			(o_in.f_get_more_results != null)? o_in.f_get_more_results : null;
			
			this.private_objs.o_input_data = o_in;
		}
		
		NSMapInterface.f_if_iframe_is_visible_activate_default_map();

		this.f_run_init_interface();
		
		//block pagination buttons
		this.o_pagination_struct.f_block_buttons();

		this.f_refresh_pagination_buttons_display();

		this.f_refresh_export_div_display();

		this.f_process_json_resp();

	},

	f_clean_results_interface: function()
	{
		//let private_objs = this.private_objs;
		//private_objs.e_holder.innerHTML = '';
		this.f_onclick_clean_results();
	},

	f_clean_results_interface_tables: function()
	{
		let private_objs = this.private_objs;

		//private_objs.o_tables.a_o_collection.forEach((o_collection) => {} )
		private_objs.o_tables.a_o_collection = [];
		
		private_objs.e_div_res_interface_tables_holder.innerHTML = '';
	},
    	
	f_process_json_resp: function ()
	{
		let this_ = this;
		let private_objs = this.private_objs;
		//private_objs.o_tables.a_o_collection = [];
		this.f_clean_results_interface_tables();

		let o_input_data = private_objs.o_input_data;

		if(o_input_data.b_use_pagination && !o_input_data.b_get_more_results_response)
		{
			this.o_pagination_struct.f_init();
		}
		else if(o_input_data.b_use_pagination && o_input_data.b_get_more_results_response)
		{
			this.o_pagination_struct.f_refresh_pagination_state();
		}
		
		
		/*
        o_input_data = 
        {
            a_table, -> [{ s_table_urn, a_geojson_feature }]  

        }

        ex: 
        {
            a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
        }
*/
        //let b_result_has_only_one_feature = false;
        if( o_input_data != null 
			&& o_input_data.b_join_list_call
            && o_input_data.a_table != null
            && o_input_data.a_table.length == 1
            && o_input_data.a_table[0].a_geojson_feature != null
            && o_input_data.a_table[0].a_geojson_feature.length == 1
            )
        {
			//b_result_has_only_one_feature = true;

            let o_feature_0 = o_input_data.a_table[0].a_geojson_feature[0];
            
            /*
            var s_feature_urn = o_feature_0.id;
            
            var b_clean_join_list = true;

            var o_in = 
            {
                s_urn: s_feature_urn, 
                b_clean_join_list: b_clean_join_list
            }
            /*
                o_in:
                {
                    s_urn, 
                    b_clean_join_list
                }
            * /
            NSObjDetails.f_open_details_by_urn(o_in);
            */

            //Show Details:

            let feature = o_feature_0;
            
            let s_record_id = feature.id.split('.')[1];
            let s_table_urn = o_input_data.a_table[0].s_table_urn
            let s_record_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn, s_record_id);
            //let s_geometry_internal_name = ;

			/*
            let o_geo_json = {
                id: s_record_urn,
                properties: feature.properties,

                //AQUIIII TODO TO DO NAO SEI SE OS CAMPOS ABAIXO SAO COMPATIVEIS COM GEOJSON, SOBRETUDO PARA GEOMETRIAS Q N SEJAM PONTOS
                bbox: feature.bbox,
                geometry: feature.geometry

            };
			*/
			let o_geo_json = NSGeoJson.f_get_geojson_feature_shallow_copy(feature);
			o_geo_json.id = s_record_urn;
 
			let b_is_icon = (feature.custom_extra_info && feature.custom_extra_info.b_is_icon) ? true: false;
			let a_icon_size_xy;
			if(b_is_icon)
			{
				a_icon_size_xy = feature.custom_extra_info.icon_size
			}

			let b_go_to = o_input_data.b_text_search_list_call;
            let b_clean_join_list = true;
            let o_in = {
                s_urn: s_record_urn,
                b_clean_join_list: b_clean_join_list,
                //o_ll: event.coordinate,
                //s_geometry_internal_name: s_geometry_internal_name,
                o_geo_json: o_geo_json,
				b_go_to: b_go_to
            }

            NSObjDetails.f_open_details_by_feature(o_in);

        }
        /*
        if ( b_result_has_only_one_feature
            || o_input_data == null
            || o_input_data.a_table == null
            || o_input_data.a_table[0].a_geojson_feature == null
            )
		{
			//refreshing visibility:
			let b_show_table = false;
			this.f_show_hide_table(b_show_table);
			this.f_onclick_clean_results();

			return;
		}
		*/


		//load DataModelInfo for all tables:
		let a_s_table_urn = [];
        o_input_data.a_table.forEach( o_table => {
            /*
            o_table: { s_table_urn, a_geojson_feature }
            */
			if(o_table.s_table_urn!=null && o_table.s_table_urn != "")
			{
				a_s_table_urn.push(o_table.s_table_urn);
			}
        });

		NSDataModelInfo.f_load_table_list____returning_promise(
			{
				a_s_table_urn: a_s_table_urn,
				b_full_info: false
			}
		).then((a_values) => {
			//console.log("---------- results_interface - just called f_load_table_list____returning_promise");
			//console.log("---------- tables loaded: " + a_s_table_urn.toString() );
			
            this_.f_all_data_model_info_loaded_();
        });

		
	},

    f_all_data_model_info_loaded_: function()
	{
		let private_objs = this.private_objs;
		let o_input_data = private_objs.o_input_data;
		

        o_input_data.a_table.forEach( o_table => {

			let s_external_table_name_i;
			if(o_table.s_table_urn) // if table data is from just one table in database
			{

				let a_urn_info = NSURN.f_get_urn_info(o_table.s_table_urn);
				let s_schema_i = a_urn_info[1];
				let s_table_internal_name_i =  a_urn_info[2];
	
				s_external_table_name_i = NSDataModelInfo.f_get_table_info(s_schema_i, s_table_internal_name_i).external_name;
			}
			else
			{
				s_external_table_name_i = "";
			}

            let o_in =
            {
                s_table_urn: o_table.s_table_urn,
                s_external_name: s_external_table_name_i,
                a_features: o_table.a_geojson_feature,
                a_column_internal_name: o_table.a_column_internal_name,
                a_column_external_name: o_table.a_column_external_name
						
            }
            /*
			o_in:
			{
				s_table_urn,
				s_external_name,
				a_features,					//[o_geo_json_feature]
				a_column_internal_name,	// (optional) used when data isn't from one table in database
				a_column_external_name		// (optional) used when data isn't from one table in database
			}
			*/
            let o_collection_base_data = new NSResultsInterfacePrivate.objs.CollectionBaseData(o_in);
			let o_collection = new NSResultsInterfacePrivate.objs.Collection(o_collection_base_data);
			private_objs.o_tables.a_o_collection.push(o_collection);	//[NSResultsInterfacePrivate.objs.Collection];

        });

		NSPageBottompanel.f_show_bottompanel();
		
		if(o_input_data.b_use_pagination)
		{
			//unblock pagination buttons
			this.o_pagination_struct.f_unblock_buttons();
			this.o_pagination_struct.f_refresh_buttons_state();
		}

		if(o_input_data.b_enable_export)
		{
			this.o_export_struct.f_init();
		}
		
	},

	o_pagination_struct:
	{
		private_objs: 
		{

			o_pagination:
			{
				i_constant_max_count: null,	//10,
				i_feature_count: null,		//current page count
				i_feature_start: null,		//current page start
				i_feature_total: null,		//current page last result index
				i_results_total: null,		//total results query produces in the db
			},
			b_pagination_buttons_blocked: false,
		},

		f_init: function()
		{
			let o_input_data = NSResultsInterfacePrivate.private_objs.o_input_data;

			

			if(o_input_data.b_use_pagination)
			{
				if(!o_input_data.b_get_more_results_response)
				{
					let o_pagination = this.private_objs.o_pagination;
					o_pagination.i_constant_max_count = o_input_data.i_feature_limit;
					o_pagination.i_results_total = o_input_data.i_feature_total_count;

					o_pagination.i_feature_count = o_input_data.a_table[0].a_geojson_feature.length;
					o_pagination.i_feature_start = 0;
					o_pagination.i_feature_total = o_input_data.a_table[0].a_geojson_feature.length;
				}
				this.f_refresh_pagination_counter_();
			}
		},

		f_refresh_pagination_state: function()
		{
			let o_input_data = NSResultsInterfacePrivate.private_objs.o_input_data;

			if(o_input_data.b_use_pagination)
			{
				if(o_input_data.b_get_more_results_response)
				{
					let o_pagination = this.private_objs.o_pagination;
	
					//o_pagination.i_constant_max_count = o_input_data.i_feature_limit;
					//o_pagination.i_results_total = o_input_data.i_feature_total_count;
					/*
					let i_feature_count_old = o_pagination.i_feature_count;
					let i_feature_start_old = o_pagination.i_feature_start;
					let i_feature_total_old = o_pagination.i_feature_total;
					*/
	
					o_pagination.i_feature_count = o_input_data.a_table[0].a_geojson_feature.length;
					o_pagination.i_feature_start = o_input_data.i_feature_offset;
					o_pagination.i_feature_total = o_pagination.i_feature_start + o_pagination.i_feature_count;
				}

				this.f_refresh_pagination_counter_();
			}

			
		},
		f_refresh_pagination_counter_ : function()
		{
			let private_objs = this.private_objs;
			let o_input_data = NSResultsInterfacePrivate.private_objs.o_input_data;

			if(o_input_data.b_use_pagination)
			{
				//update pagination counter
				//$("#pagination_counter").html( private_objs.o_pagination.i_feature_total - 1  + "/" + private_objs.o_pagination.i_results_total )
				let e_pagination_counter = NSResultsInterfacePrivate.private_objs.e_pagination_counter;

				e_pagination_counter.innerHTML = `${private_objs.o_pagination.i_feature_total || 0} / ${private_objs.o_pagination.i_results_total || 0}`;

			}
		},
	
		f_onclick_button_next: function ()
		{
			let b_is_disabled = this.f_button_next_is_disabled();
			if(b_is_disabled)
			{
				return;
			}
			
			let private_objs_local = this.private_objs;
			let o_pagination = private_objs_local.o_pagination;
			let i_constant_max_count = o_pagination.i_constant_max_count;
			let i_feature_count = o_pagination.i_feature_count;
			let i_feature_start = o_pagination.i_feature_start;
			let i_feature_total = o_pagination.i_feature_total;
			
			let i_start = i_feature_start + i_feature_count;
			
			this.f_get_another_page_(i_start);
		
		},
		f_onclick_button_previous: function ()
		{
			let b_is_disabled = this.f_button_previous_is_disabled();
			if(b_is_disabled)
			{
				return;
			}
			
			let private_objs_local = this.private_objs;
			let o_pagination = private_objs_local.o_pagination;
			
			let i_constant_max_count = o_pagination.i_constant_max_count;
			let i_feature_count = o_pagination.i_feature_count;
			let i_feature_start = o_pagination.i_feature_start;
			let i_feature_total = o_pagination.i_feature_total;
			
			let i_start = i_feature_start - i_constant_max_count;
			
			this.f_get_another_page_(i_start);
		
		},
		f_get_another_page_: function(i_start)
		{
			var this_ = this;
			var private_objs_global = NSResultsInterfacePrivate.private_objs;
			
			
			/*
				o_in = {
					i_feature_offset,
					i_feature_limit
				}
			*/
			var o_in = {
				//i_start: i_start,
				//i_feature_count: private_objs_global.o_pagination.i_constant_max_count +1
				i_feature_offset: i_start,
				i_feature_limit: this.private_objs.o_pagination.i_constant_max_count
			}
			
			//NSAdvancedSearchQueryInterface.o_Execute_Query.f_get_more_results(o_in);
			private_objs_global.o_input_data.f_get_more_results(o_in);
			

		},
		f_refresh_buttons_state: function()
		{
			let private_objs_global = NSResultsInterfacePrivate.private_objs;
			let private_objs_local = this.private_objs;
			let o_pagination = private_objs_local.o_pagination;
			
			var i_constant_max_count = o_pagination.i_constant_max_count;
			var i_feature_count = o_pagination.i_feature_count;
			var i_feature_start = o_pagination.i_feature_start;
			var i_feature_total = o_pagination.i_feature_total;
			var i_results_total = o_pagination.i_results_total;			

			let b_pagination_buttons_blocked = private_objs_local.b_pagination_buttons_blocked;

			//feature_start start on 1
			var b_exists_previous = (i_feature_start>1)? true: false;
			var b_exists_next = (i_feature_start + i_feature_count < i_results_total)? true: false;
		
			var e_button_results_interface_previous_page = private_objs_global.e_button_results_interface_previous_page;
			var e_button_results_interface_next_page = private_objs_global.e_button_results_interface_next_page;
			
			if(e_button_results_interface_previous_page != null && e_button_results_interface_next_page != null)
			{
				let s_CONST_DISABLED_CLASS = 'disabled';
				//Previous:
				if( b_pagination_buttons_blocked || !b_exists_previous)
				{
//					e_button_results_interface_previous_page.setAttribute("disabled", "disabled");
					if(! e_button_results_interface_previous_page.classList.contains(s_CONST_DISABLED_CLASS) )
					{
						e_button_results_interface_previous_page.classList.add(s_CONST_DISABLED_CLASS);
					}
				}
				else
				{
//					e_button_results_interface_previous_page.removeAttribute("disabled");
					e_button_results_interface_previous_page.classList.remove(s_CONST_DISABLED_CLASS);
				}
			
				//Next:
				if( b_pagination_buttons_blocked || !b_exists_next)
				{
//					e_button_results_interface_next_page.setAttribute("disabled", "disabled");
					if(! e_button_results_interface_next_page.classList.contains(s_CONST_DISABLED_CLASS) )
					{
						e_button_results_interface_next_page.classList.add(s_CONST_DISABLED_CLASS);
					}
				}
				else
				{
//					e_button_results_interface_next_page.removeAttribute("disabled");
					e_button_results_interface_next_page.classList.remove(s_CONST_DISABLED_CLASS);
				}
			}
		
			
		
		},
		f_block_buttons: function()
		{
			this.private_objs.b_pagination_buttons_blocked = true;
			this.f_refresh_buttons_state();			
		},
		f_unblock_buttons: function()
		{
			this.private_objs.b_pagination_buttons_blocked = false;
			this.f_refresh_buttons_state();
		},
		f_button_previous_is_disabled: function()
		{
			var private_objs_global = NSResultsInterfacePrivate.private_objs;
			var e_button_results_interface_previous_page = private_objs_global.e_button_results_interface_previous_page;
			
			var b_is_disabled = this.f_button_is_disabled(e_button_results_interface_previous_page);
			
			return b_is_disabled;
		},
		f_button_next_is_disabled: function()
		{
			var private_objs_global = NSResultsInterfacePrivate.private_objs;
			var e_button_results_interface_next_page = private_objs_global.e_button_results_interface_next_page;
			
			var b_is_disabled = this.f_button_is_disabled(e_button_results_interface_next_page);
			
			return b_is_disabled;
		},
		f_button_is_disabled: function(e_button)
		{
			var b_is_disabled = e_button.hasAttribute("disabled");
			return b_is_disabled;
		}
		
	},

	o_export_struct:
	{
		private_objs: 
		{

			o_formats: {
				a_export_format_desc: ["DXF", "SHP", "CSV"],
				a_export_format_key: ["dxf", "shape-zip", "csv"],
				a_export_format_b_needs_geometry: [true, true, false],
			},
			o_combo_export_format: null
		},

		f_init: function()
		{
			let private_objs = this.private_objs;
			let private_objs_global = NSResultsInterfacePrivate.private_objs;
			let e_div_results_interface_export = private_objs_global.e_div_results_interface_export;
			let e_select_results_interface_export_format = private_objs_global.e_select_results_interface_export_format;
			let e_button_results_interface_export_execute = private_objs_global.e_button_results_interface_export_execute;
			
			let f_onSelect_format_CB = function () {};

			let s_id_select_results_interface_export_format = e_select_results_interface_export_format.getAttribute("id");
			private_objs.o_combo_export_format = new NSCombos.objs.Combo(s_id_select_results_interface_export_format, f_onSelect_format_CB, [], null);

			let o_combo_format_data = this.f_get_combo_format_data();
			
            private_objs.o_combo_export_format.reset(o_combo_format_data.a_desc, o_combo_format_data.a_key);

			e_button_results_interface_export_execute.o
			
		},
		/**
		 	@returns {object} {
					{array} "a_key",
					{array} "a_desc"
				}
			@summary
			returns
			{
				{array} a_key,
				{array} a_desc
			} 
			
		 */
		f_get_combo_format_data: function()
		{
			let private_objs_global = NSResultsInterfacePrivate.private_objs;
			let private_objs = this.private_objs;
			let o_input_data = private_objs_global.o_input_data;

			let a_key = [];
			let a_desc = [];

			let b_all_result_tables_have_geometry = true;
			for(let i=0; i<o_input_data.a_table.length; i++)
			{
				let o_table = o_input_data.a_table[i];
				/*
				o_table: { s_table_urn, a_geojson_feature }
				*/						
				let o_geom_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info_by_urn(o_table.s_table_urn);
				let b_table_has_geometry = (o_geom_field_info!=null)? true : false;

				if(!b_table_has_geometry)
				{
					b_all_result_tables_have_geometry = false;
					break;
				}
			}

			let a_export_format_key = private_objs.o_formats.a_export_format_key;
			let a_export_format_desc = private_objs.o_formats.a_export_format_desc;
			let a_export_format_b_needs_geometry = private_objs.o_formats.a_export_format_b_needs_geometry;
			for(let i=0; i<a_export_format_b_needs_geometry.length; i++)
			{
				let s_key_i = a_export_format_key[i];
				let s_desc_i = a_export_format_desc[i];
				let b_export_format_needs_geometry_i = a_export_format_b_needs_geometry[i];
				if(b_export_format_needs_geometry_i)
				{
					if(b_all_result_tables_have_geometry)
					{
						a_key.push(s_key_i);
						a_desc.push(s_desc_i);

					} //else format is not added

				}
				else // format is allways added
				{
					a_key.push(s_key_i);
					a_desc.push(s_desc_i);
				}

			}

			return {a_key: a_key, a_desc: a_desc}

		},
		f_onclick_button_execute: function()
		{
			let private_objs_global = NSResultsInterfacePrivate.private_objs;
			let private_objs = this.private_objs;
			let o_input_data = private_objs_global.o_input_data;
			let o_tables = private_objs_global.o_tables;

			
			let s_cache_limitation_param_value = NSFunctions.guidGenerator();
			//let a_map_bounds = Module_Map.f_get_map_bounds();
			let s_max_fetures = 100000;
			let s_output_format = private_objs.o_combo_export_format.getSelectedKey();

			let a_url = [];
			for(let i=0; i<o_input_data.a_table.length; i++)
			{
				/*
				o_table: { s_table_urn, a_geojson_feature }
				*/	
				let o_table = o_input_data.a_table[i];
				let s_table_internal_name = NSURN.f_get_urn_table_name(o_table.s_table_urn);
				let s_id_list = "";
				o_table.a_geojson_feature.forEach( (o_feature) =>
					{
						let s_id = o_feature.id.split(".")[1];
						s_id_list += "," + s_id;
					}
				);
				s_id_list = s_id_list.substring(1);

				
				let o_collection = o_tables.a_o_collection[i]; // {NSResultsInterfacePrivate.objs.Collection}
				let s_column_internal_name_list = o_collection.a_column_internal_name.join(",");
				
				//get_export_url : function( s_table_name, max_features, a_bounding_box, s_id_list, s_cache_limitation_param_value, s_output_format)
				//let s_url = NSServerCalls.geoserver.wfs.get_export_url(s_table_internal_name, s_max_fetures, null, s_id_list, s_cache_limitation_param_value, s_output_format);
				let b_export_format_needs_geometry = NSServerCalls.geoserver.wfs.f_b_export_format_needs_geometry(s_output_format);
				if(b_export_format_needs_geometry)
				{
					let o_provider_table_geometry_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info_by_urn(o_table.s_table_urn);
					if(o_provider_table_geometry_field_info != null)
					{
						let s_geometry_internal_name = o_provider_table_geometry_field_info.internal_name;
						s_column_internal_name_list	+= ( s_column_internal_name_list.length > 0 ) ? ","+s_geometry_internal_name : s_geometry_internal_name;
					}
				}
				let s_url = NSServerCalls.geoserver.wfs.get_export_url(s_table_internal_name, s_max_fetures, null, s_id_list, s_cache_limitation_param_value, s_output_format, s_column_internal_name_list);
				a_url.push(s_url);

			}

			a_url.forEach((s_url_i)=>
			{
				//console.log("s_url="+ s_url);
				let s_guid = NSFunctions.guidGenerator();
				window.open(s_url_i, "_new_browsing_context_" + s_guid);
			});
			

		}



		
	},


	/**************************************************************************************************************/
	/**************************************************************************************************************/
	/**************************************************************************************************************/
	/**************************************************************************************************************/

    objs:
	{
		/*
		o_in: {NSResultsInterfacePrivate.objs.CollectionBaseData}
		*/
		Collection: function(o_in)
		{
			this.o_collection_base_data = o_in;
			
			this.e_div_table_holder = null;
			
			this.a_column_internal_name = null;     //only the columns to be presented on the table are present
            this.a_column_name = null;              //only the columns to be presented on the table are present
			this.o_table = null; 		//	{NSTables.Objs.Table}
			this.o_data_table = null;	//	{NSTables.Objs.DataTable();}
			
			this.f_init_();
            
		},
		
		/*
		o_in:
		{
			s_table_urn,
			s_external_name,
			a_features,			//[o_geo_json_feature]
			a_column_internal_name,	// (optional) used when data isn't from one table in database
			a_column_external_name		// (optional) used when data isn't from one table in database
		}
		*/
		CollectionBaseData: function(o_in)
		{
			this.s_table_urn = o_in.s_table_urn;
			this.s_external_name = o_in.s_external_name;
			this.a_features = o_in.a_features;
			this.a_column_internal_name = o_in.a_column_internal_name;
			this.a_column_external_name = o_in.a_column_external_name;
		},
		
		
		init_: function()
		{
			this.Collection.prototype.f_init_ = function()
			{
				let b_text_search_list_call = NSResultsInterfacePrivate.private_objs.o_input_data.b_text_search_list_call;

				let o_collection_base_data = this.o_collection_base_data;
				
                let s_table_urn =o_collection_base_data.s_table_urn;

				//getting columns namespaceURI
                let a_column_internal_name = [];
				let a_column_name =[];
				let aTH_CSS = [];
				let aTD_CSS = [];

				if(o_collection_base_data.a_features.length > 0)
				{
					if(b_text_search_list_call) // Text Search results may not be from a single table!
					{
						a_column_internal_name =	[].concat(o_collection_base_data.a_column_internal_name);
						a_column_name =				[].concat(o_collection_base_data.a_column_external_name);
					}
					else
					{
						
						let a_urn_info = NSURN.f_get_urn_info(s_table_urn);
						let s_schema = a_urn_info[1];
						let s_table_internal_name =  a_urn_info[2];


						//let a_column_internal_name_in_feature = Object.keys(o_collection_base_data.a_features[0].properties);
						let o_table_info = NSDataModelInfo.f_get_table_info(s_schema, s_table_internal_name);
						let a_col_info_field_internal_name = o_table_info.extra.a_ordered_visible_columns;
	
						a_col_info_field_internal_name.forEach(s_column_internal_name_i => {
							let o_field_info = NSDataModelInfo.f_get_field_info(s_schema, s_table_internal_name, s_column_internal_name_i);
							let b_field_is_visible = (o_field_info.is_hidden == null || o_field_info.is_hidden == false )? true : false;
							let b_field_is_geometry = NSDataTypes.f_type_is_geometry(o_field_info.data_type);
							if ( !o_field_info.is_join && b_field_is_visible && !b_field_is_geometry )
							{
								a_column_internal_name.push(o_field_info.internal_name);
								a_column_name.push(o_field_info.external_name);
							}
							
						});
							
					}
				}
				
				for(let i=0; i<a_column_name.length; i++)
				{
					aTH_CSS.push("results-table-cell")
					aTD_CSS.push("results-table-cell")
				}

                this.a_column_internal_name = a_column_internal_name;
				this.a_column_name = a_column_name;
			
			
				let o_in = 
				{
                    a_column_internal_name: a_column_internal_name,
					a_column_name: a_column_name,
					a_b_col_sortable: null,
					a_sort_cmp_function: null, //    (o1,o2) returns true if (o1 < o2)
					aTH_CSS: aTH_CSS, 
					aTD_CSS: aTD_CSS,
				}
				this.f_initialize_table_(o_in);
				this.f_fill_table_();
				

			},
			this.Collection.prototype.f_initialize_html_holder_= function()
			{
				let s_external_name = this.o_collection_base_data.s_external_name.trim();
				let private_objs_global = NSResultsInterfacePrivate.private_objs;
				let s_html = `
					<div class='table-holder'>
						<div class="table-title ${s_external_name ? '' : 'd-none'}">${s_external_name || ''}</div>
						<div class="table-container"></div>
					</div>
				`;
					
				let e_div_res_interface_tables_holder = private_objs_global.e_div_res_interface_tables_holder;
				let e_div_table_holder = NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_res_interface_tables_holder, s_html);
				
				this.e_div_table_holder = e_div_table_holder.querySelector('.table-container');
			}
			/*
				o_in = 
				{
                    a_column_internal_name,
					a_column_name,
					a_b_col_sortable,
					a_sort_cmp_function, //    (o1,o2) returns true if (o1 < o2)
					aTH_CSS, 
					aTD_CSS,
				}
			*/
			this.Collection.prototype.f_initialize_table_= function(o_in)
			{
				let private_objs_global = NSResultsInterfacePrivate.private_objs;
                let a_column_internal_name = o_in.a_column_internal_name;
				let a_column_name = o_in.a_column_name;
				let a_b_col_sortable = o_in.a_b_col_sortable;
				let a_sort_cmp_function = o_in.a_sort_cmp_function;
				let aTH_CSS = o_in.aTH_CSS;
				let aTD_CSS = o_in.aTD_CSS;
				
				if(this.o_table != null)
				{
					this.o_table.destroy();
					this.o_table = null;
				}
				
				//initializing table holder:
				this.f_initialize_html_holder_();
				
				
				let aColumns = new Array();
				/*
				aColumns.push('Structure');
				aColumns.push('WMS No');
				*/
				aColumns = aColumns.concat(a_column_name);
				
				for (let i=0; i<aColumns.length; i++)
				{
					let s_column_internal_name_i = a_column_internal_name[i];
					let s_column_external_name_i = aColumns[i];
					
					let s_table_urn = this.o_collection_base_data.s_table_urn;
					if(s_table_urn) // not all reults tables have data just from one database table
					{
						let a_urn_info = NSURN.f_get_urn_info(s_table_urn);
						let s_schema = a_urn_info[1];
						let s_table_internal_name = a_urn_info[2];
	
						
						let o_field_info_i = NSDataModelInfo.f_get_field_info(s_schema, s_table_internal_name, s_column_internal_name_i);
						/*
						//take care of units, old version :         AQUIIIIIIIIIIIII TODO TO DO
						if(o_field_schema_info_i){
							let s_field_unit = o_field_schema_info_i.unit ? o_field_schema_info_i.unit : null;
							if(s_field_unit != null && s_field_unit != "")
							{
								s_column_external_name_i += " (" + s_field_unit+")";
								aColumns[i] = s_column_external_name_i;
							}
						}
						*/

					}
					

				}

				let e_TableHolder = this.e_div_table_holder;         
				let sTableCSS = 'table table-sm table-bordered table-hover table-nowrap';
				let sTR_SELECTED_CSS = "selected";
				let b_multiple_selection = false;
				let b_multiple_selection_classic_style = true;
				let b_sortable = false;
				let sTR_CSS = [""];
				
				let o_table_in = {
					eHTMLHolder: e_TableHolder, 
					aColumns: aColumns, 
					sTableCSS: sTableCSS, 
					aTH_CSS: aTH_CSS, 
					aTD_CSS: aTD_CSS, 
					sTR_CSS: sTR_CSS, 
					sTR_SELECTED_CSS: sTR_SELECTED_CSS, 
					b_multiple_selection: b_multiple_selection, 
					b_multiple_selection_classic_style: b_multiple_selection_classic_style,
					b_sortable: b_sortable,
					a_b_col_sortable: a_b_col_sortable,    // default b_sortable determines if all are sortable or not
					a_sort_cmp_function: a_sort_cmp_function, //    ->  a[f(o1,o2)]    -> f returns true if o1 < o2 , default string comparisson...
				};
				
				let table = new NSTables.Objs.Table(o_table_in);
				this.o_table = table;	
				
				//------------------------------------------
				//Event Handlers:
				//table
				let this_ = this;
				table.addRowClickEventFunction(
					function () {
					  //alert("row selected!");
					  //this_.f_selectHandler(this_);
					  this_.f_table_on_select_handler_();
				});
				
				//refreshing visibility:
				let b_show_table =  (a_column_name.length > 0)? true: false;
				NSResultsInterfacePrivate.f_show_hide_table(b_show_table);

			}
			
			this.Collection.prototype.f_table_on_select_handler_= function()
			{
				let this_ = this;
				let private_objs_global = NSResultsInterfacePrivate.private_objs;
				let b_text_search_list_call = private_objs_global.o_input_data.b_text_search_list_call;
				
				let o_table = this.o_table;
				let a_selected_keys = o_table.getSelection_keys();
				
				if(a_selected_keys.length > 0)
				{  
                    let s_record_urn = a_selected_keys[0];
					let s_table_urn = NSURN.f_create_table_urn_from_record_urn(s_record_urn);

                    let feature = this.f_get_feature_by_record_urn(s_record_urn);
					
					let [o_tree_node] = NSOverlays_.f_get_all_active_overlays()
						.map((el) => el.tree_node)
						.sort((el1, el2) => {
							if (el1.type === 'vector' && el2.type !== 'vector') return -1;
							if (el1.type !== 'vector' && el2.type === 'vector') return 1;
							return 0;
						})
						.filter((el) => el.urn === s_table_urn);

					let a_icon_size_xy = o_tree_node && o_tree_node.icon_size;

					if(b_text_search_list_call)
					{
						let a_urn_info = NSURN.f_get_urn_info(s_record_urn);
						let s_schema = a_urn_info[1];
						let s_table_internal_name = a_urn_info[2];

						
						//let o_table_info = NSDataModelInfo.f_get_table_info(s_schema, s_table_internal_name);
						let o_geom_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info(s_schema, s_table_internal_name);

						let b_go_to = b_text_search_list_call;

						/**
							@example
							o_in:
							{
								tree_node_id,
								s_urn, 
								b_clean_join_list,
								o_ll,						// (optional) - {google.maps.LatLng}
								o_geo_json					// (optional) - {GeoJson}
								s_geometry_internal_name	// internal name of the geometry field
								b_is_icon,
								a_icon_size_xy,				//[width, height]
								b_go_to
							}
						*/
						NSObjDetails.f_open_details_by_urn({
							s_urn: s_record_urn,
							s_geometry_internal_name: (o_geom_field_info)? o_geom_field_info.internal_name : null,
							b_go_to: true,
							b_is_icon: a_icon_size_xy !== undefined,
                			a_icon_size_xy: a_icon_size_xy
						});
					}
					else
					{
						let o_geo_json = NSGeoJson.f_get_geojson_feature_shallow_copy(feature);
						o_geo_json.id = s_record_urn;
			
						let b_is_icon = (feature.custom_extra_info && feature.custom_extra_info.b_is_icon) ? true: false;
						
						if(b_is_icon)
						{
							a_icon_size_xy = feature.custom_extra_info.icon_size
						}
	
						let b_clean_join_list = false;
						let b_go_to = b_text_search_list_call;

						let o_in = {
							s_urn: s_record_urn,
							b_clean_join_list: b_clean_join_list,
							//o_ll: event.coordinate,
							//s_geometry_internal_name: s_geometry_internal_name,
							o_geo_json: o_geo_json,
							b_go_to: true,
							b_is_icon: b_is_icon || a_icon_size_xy !== undefined,
                			a_icon_size_xy: a_icon_size_xy
						}
	
						NSObjDetails.f_open_details_by_feature(o_in);
					}
				}
			}
			
			this.Collection.prototype.f_fill_table_ = function()
			{
				let private_objs_global = NSResultsInterfacePrivate.private_objs;
                let o_input_data = private_objs_global.o_input_data;
				let b_text_search_list_call = private_objs_global.o_input_data.b_text_search_list_call;
				
				let o_data_table = new NSTables.Objs.DataTable();
                let a_column_internal_name = this.a_column_internal_name;
				let a_column_name = this.a_column_name;
                let s_table_urn = this.o_collection_base_data.s_table_urn;
				let a_feature = this.o_collection_base_data.a_features;

				for(let i=0; i<a_feature.length; i++)
				{
					let o_feature_i = a_feature[i];
					let s_id = o_feature_i.id;
                    
                    let s_record_id = s_id.split('.')[1];
					if(b_text_search_list_call) // not all tables data comes from one table in database
					{
						s_table_urn = o_feature_i.properties_extra.search_table_urn; //each row may be from a diferent table in database
					}
                    let s_record_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn, s_record_id);
					let a_feature_urn_info = NSURN.f_get_urn_info(s_record_urn);
					let s_schema = a_feature_urn_info[1];
					let s_table_internal_name = a_feature_urn_info[2];
					
					
					let a_row_values = [];
					for(let j=0; j<a_column_internal_name.length; j++)
					{
						let s_column_internal_name_j = a_column_internal_name[j];
                        //var s_column_j = a_column_name[j]; //->external_name
						let s_value_j = o_feature_i.properties[s_column_internal_name_j];//"" + o_feature_i.properties[s_column_internal_name_j];
						
                        let o_field_info_j = NSDataModelInfo.f_get_field_info(s_schema, s_table_internal_name, s_column_internal_name_j);
						let s_fied_type_j = (o_field_info_j)? o_field_info_j.data_type : NSDataTypes.f_get_text_type(); // if no info, defaults to text
						
						let s_value_html_j;
						if( s_fied_type_j && NSDataTypes.f_type_is_number_with_decimal_places(s_fied_type_j))
						{
							if(s_value_j != null && s_value_j != "")
							{
								let n = parseFloat(s_value_j);
								let i_dp = 2;	//decimal places
								
								s_value_html_j = NSFunctions.roundNumber(n, i_dp);
							}
							else
							{
								s_value_html_j = "";
							}
						}
						else if( s_fied_type_j && NSDataTypes.f_type_is_date_or_datetime(s_fied_type_j))
						{
							if(s_value_j != null && s_value_j != "")
							{
								s_value_html_j = NSDateDatetime.NSDate.f_get_value_as_fe_presentation_date_string_vers_02(s_value_j);
							}
							else
							{
								s_value_html_j = "";
							}
						}
						else
						{
							s_value_html_j = (s_value_j != null)? s_value_j :  "";
						}
						
						s_value_html_j += "";
						a_row_values.push(s_value_html_j);
						
					}
					o_data_table.addRows([a_row_values], [s_record_urn]);
				}
				
				let table = this.o_table;
				table.addRows(o_data_table);
				
				this.o_data_table = o_data_table;
				
			
			}

            
            this.Collection.prototype.f_get_feature_by_record_urn = function(s_record_urn)
            {
                let a_record_urn_info = NSURN.f_get_urn_info(s_record_urn);
                let s_record_id = a_record_urn_info[3];

                let a_features = this.o_collection_base_data.a_features;
                for(let i=0; i<a_features.length; i++)
                {
                    let o_feature_i = a_features[i];
                    if(o_feature_i.id.split(".")[1] == s_record_id)
                    {
                        return o_feature_i;
                    }
                }

            }
		
		}
	}
	

}